import { render } from "./OpenLinkSVG.vue?vue&type=template&id=5dd65127"
import script from "./OpenLinkSVG.vue?vue&type=script&lang=js"
export * from "./OpenLinkSVG.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__